import { render } from "./FactoryComponent.vue?vue&type=template&id=3c1ce6c9&bindings={\"factory\":\"props\",\"setFlickityDots\":\"options\",\"flickityOptions\":\"data\"}"
import script from "./FactoryComponent.vue?vue&type=script&lang=js"
export * from "./FactoryComponent.vue?vue&type=script&lang=js"

import "./FactoryComponent.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script